import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./index.less";
import * as echarts from "echarts";
import Cookies from "js-cookie";
import myPlugin from "@/plugins";
// import locale from "element-ui/lib/locale/lang/en";
import Axios from 'axios';
import axios from "axios";
Vue.prototype.$http = Axios;
Axios.defaults.baseURL = 'qy/boss'; // 线上：qy/boss 本地：/api

// 国际化设置
// Vue.use(ElementUI, { locale });
Vue.use(ElementUI);
Vue.use(myPlugin);
Vue.prototype.$echarts = echarts;
Vue.prototype.$Cookies = Cookies;
Vue.config.productionTip = false;

  // 添加请求拦截器
  axios.interceptors.request.use(
    function (config: any) {
      // 在发送请求之前做些什么
      const { loading = true } = config;
      // config.headers.token = vm.$Cookies.get("vue_admin_token");
	  // config.headers.Authorization("token",vm.$Cookies.get("vue_admin_token"));
	    config.headers.Authorization = Cookies.get("vue_admin_token");
      return config;
    },
    function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );

const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vm;
